// src/component/datatable2/components/PaginatorTemplate.tsx

import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import type { TFunction } from 'i18next';

export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

interface PaginatorTemplateOptions {
    t: TFunction;
    currentPage: number;
    pageInputTooltip: string;
    onCurrentPageChange: (page: number) => void;
    /** Enter (or blur) in the page input; `options` are PrimeReact's template options. */
    onPageInputCommit: (event: { key: string; target?: unknown }, options: any) => void;
}

/** PrimeReact paginator template of DataTable2: ‹ [page] of N › and "Rows on page". */
export function createPaginatorTemplate({
    t,
    currentPage,
    pageInputTooltip,
    onCurrentPageChange,
    onPageInputCommit,
}: PaginatorTemplateOptions) {
    return {
        layout: 'PrevPageLink JumpToPageInput CurrentPageReport NextPageLink RowsPerPageDropdown',

        CurrentPageReport: (options: any) => (
            <span className="dt2-page-report">
                {t('dataTable.of')} {options.totalPages}
            </span>
        ),

        JumpToPageInput: (options: any) => (
            <span className="jump-to-input">
                <InputText
                    size={3}
                    className="ml-1 small"
                    value={String(currentPage)}
                    tooltip={pageInputTooltip}
                    onKeyDown={(event: any) => onPageInputCommit(event, options)}
                    onBlur={(event: any) => onPageInputCommit({ key: 'Enter', target: event.target }, options)}
                    onChange={(event: any) => onCurrentPageChange(Number(event.target.value))}
                    keyfilter="int"
                />
            </span>
        ),

        RowsPerPageDropdown: (options: any) => (
            <div className="dt2-rows-per-page">
                <span className="dt2-rows-per-page__label">
                    {t('dataTable.rowsOnPage', 'Rows on page:')}
                </span>
                <Dropdown
                    value={options.value}
                    options={ROWS_PER_PAGE_OPTIONS.map(value => ({ label: String(value), value }))}
                    onChange={options.onChange}
                    className="dt2-rows-per-page__dropdown"
                />
            </div>
        ),
    };
}
